import React from "react";
import MapView, { Marker, DrawingTools, MapControls, Popup, MapConstant } from "../../../lib/Map";
import { ShipmentsMarker, TerminalMarker } from "../../../components/mapComponents/Markers";
import {  CustomerPopup, ZonePopUpInfo } from "../../../components/mapComponents/Popups";
import appConstant from "../../../appConstants";
import Events from"../../../utilities/EventEmitter";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withTheme } from "@material-ui/core";
import StyledToolTip from "../../common/StyledToolTip";
import { withAppConfig } from "../../../appConfigContext";
import { getCustomerDataByStopType } from "./EditCustomer/utils";

class MapsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.terminalLocation =this.props.userData.userProfile && this.props.userData.userProfile.terminal.location; 
        this.state = {
            zoneInfo: null,
            selectedCustomer: null,
            gridSelectedCustomers: [],
        }
    }

    componentDidMount(){
        this.props.glEventHub.on('customerSelectedonGrid',this.onGridCustomerSelected);
    }

    componentWillUnmount(){
        this.props.glEventHub.off('customerSelectedonGrid',this.onGridCustomerSelected);
    }
    
    onMapClicked = () => {
        this.hideAllPopups();
    }

    onZoneClicked = (zoneInfo) => {
      this.setState({ zoneInfo });
    };

    onTerminalClicked = ({ marker }) => {
        this.setState({
            selectedCustomer: null,
        })
    }

    onGridCustomerSelected = (options) => {
      const {selectedCustomers, stopType} =  options;
      const gridSelectedCustomers = selectedCustomers.slice(0, 500); // Get Top 500 markers , Rendering large number of markers degrade app performance as well as dont provide much insight to user
      this.setState((prevState) => ({
        gridSelectedCustomers,
        selectedCustomer: gridSelectedCustomers.includes(
          prevState.selectedCustomer?.data.code
        )
          ? prevState.selectedCustomer
          : null,
          stopType,
      }));
    };
    onCustomerMarkerClicked = (customer) => {
        this.setState({
            selectedCustomer: {...customer},
        });
    }

    
    hideAllPopups = () => {
        this.setState({
            selectedCustomer: null,
            zoneInfo: null,
        });
    }

    onScaleDrawingComplete = () => {}

    isCustomerActive = (code) => {
      return this.state.selectedCustomer?.data?.code === code;
    }

    render() {
        const { theme } = this.props;
        this.terminalLocation =this.props.userData.userProfile && this.props.userData.userProfile.terminal.location;
        return (
          <div className="customerMapContainer" ref={this.mapRef}>
            <MapView
              zoom={11}
              initialCenter={this.terminalLocation}
              onClick={this.onMapClicked}
              mapId={"customerMap"}
              mapTheme={theme.themeName}
              center={this.terminalLocation}
              eventHub={this.props.glEventHub}
              mapConfig={this.props.configJSON?.maps}
            >
              <MapControls
                controlOptions={{
                  zoomControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  satelliteViewControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  reCenterMapControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  showZones: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                    terminalID: this.props.userData.userProfile.terminal.code,
                    onZoneClicked: this.onZoneClicked,
                    geoJson: this.props.userData.userProfile?.geoJson
                  },
                }}
              />

              <Marker
                position={this.terminalLocation}
                onClick={this.onTerminalClicked}
                animation
                // anchor point is the point in the image which should overlap the location,
                // Terminal image is of different size than the marker so we can override the default value as shown below
                anchorPoint={{ x: 20, y: 20 }}
                zIndex={1}
                forceUpdate={true}
                isActiveShipment={true}
              >
                <TerminalMarker
                  data={this.props.userData.userProfile.terminal}
                  color={theme.terminalContentColor}
                />
              </Marker>
              {this.state.gridSelectedCustomers?.map((customer) => {
                const isActive = this.isCustomerActive(customer.code);
                return (
                  <Marker
                    data={customer}
                    position={{
                      lat: customer.latitude,
                      lng: customer.longitude,
                    }}
                    key={`${customer.code}`}
                    onClick={this.onCustomerMarkerClicked}
                    isActiveShipment
                    zIndex={isActive ? 1 : 0}
                  >
                    <StyledToolTip title={customer.name}>
                      <div>
                        <ShipmentsMarker
                          dimension={isActive ? "35px" : "23px"}
                          backgroundColor={
                            isActive
                              ? appConstant.Colors.markerActiveColor
                              : null
                          }
                        />
                      </div>
                    </StyledToolTip>
                  </Marker>
                );
              })}

              <DrawingTools
                // options are controlled through header, DrawingToolbox
                // This is just to create a mapbox-draw object for the map and pass it to the DrawingToolbox
                eventHub={Events}
                onDrawingComplete={this.onScaleDrawingComplete}
              />

              {this.state.selectedCustomer && (
                <Popup
                  marker={this.state.selectedCustomer.marker}
                  // forceRender will rerender the child component into the infowindow,
                  // set to true when theme changes or data is updated for selected shipment
                  position={this.state.selectedCustomer.position}
                  forceRender={this.state.themeChanged}
                  key={`${this.state.selectedCustomer.data.code}_customerPopup`}
                >
                  <CustomerPopup
                    data = {getCustomerDataByStopType(
                      this.state.selectedCustomer.data,
                      this.state.stopType
                    )}
                    theme={this.props.theme.themeName}
                  />
                </Popup>
              )}
              {this.state.zoneInfo && (
                <Popup isCloseButton position={this.state.zoneInfo.position}>
                  <ZonePopUpInfo data={this.state.zoneInfo.data} />
                </Popup>
              )}
            </MapView>
          </div>
        );
    }
}
export default compose(withTheme(), withUserProfile, withAppConfig)(MapsComponent);
